<div class="filter-tray">
    <div class="tray-items">
        <div class="tray-row">
            <span class="tray-row-label">{{ 'filter.archived' | translate }}</span>
        </div>
    </div>
    <div class="tray-footer">
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
